import React from 'react';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  variant?: 'default' | 'neu';
}

export const Textarea: React.FC<TextareaProps> = ({ 
  className = '', 
  variant = 'default',
  ...props 
}) => {
  const baseClasses = variant === 'neu' ? 'input-neu' : 'input';

  return (
    <textarea 
      className={`${baseClasses} resize-none ${className}`} 
      {...props}
    />
  );
};
